import { initSharedPageInteractions } from './shared_page_interactions'

export function initSupervisorSingle() {
  initSharedPageInteractions({ smoothAnchorLinks: 'all' })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSupervisorSingle)
} else {
  initSupervisorSingle()
}
